import React from "react";
import { Typography } from "@mui/material";
import { Skeleton } from "@mui/lab";
import { Col, Row } from "reactstrap";
import { Fragment } from "react";

function TeamPending({ loading, stylePDF, numberRow, ...props }) {
  return (
    <Fragment>
      {loading ? (
        <div style={{ padding: "0.5rem" }}>
          {Array.from(Array(numberRow || 4).keys()).map((cur, i) => {
            return (
              <Row key={"ske2" + i} className="m-1">
                {!stylePDF && (
                  <Col md="4">
                    <Typography component="div" variant={"body1"}>
                      <Skeleton variant="rectangular" />
                    </Typography>
                  </Col>
                )}
                <Col md={stylePDF === "PDF" ? "12" : "8"}>
                  <Typography component="div" variant={"body1"}>
                    <Skeleton variant="rectangular" />
                  </Typography>
                </Col>
              </Row>
            );
          })}
        </div>
      ) : (
        props.children
      )}
    </Fragment>
  );
}
export default TeamPending;
